import { TextSmall } from '@/components/Texts';
import React from 'react';

const DataSecurity = () => {
  return (
    <>
      <TextSmall fontWeight={700}>(6) Data security</TextSmall>
      <TextSmall>
        We use appropriate technical and organizational security measures to
        protect your data against accidental or intentional manipulation,
        partial or complete loss, destruction or against unauthorized access by
        third parties (e.g. TSL encryption for our website), taking into account
        the state of the art, implementation costs and the nature, scope,
        context and purpose of the processing, as well as the existing risks of
        a data breach (including its probability and impact) for the data
        subject. Our security measures are continuously improved in line with
        technological developments.
      </TextSmall>
      <TextSmall>
        Diment takes all reasonable endeavors to protect and safeguard
        Personal Information, but there are protective measures you should take,
        as well. Do not share your Personal Information with others unless you
        clearly understand the purpose of their request for it and you know with
        whom you are dealing. Do not keep sensitive Personal Information in your
        e-mail inbox or on Webmail. If you are asked to assign passwords to
        connect you to your Personal Information, you should use a secure
        password and always use two-factor authentication (2FA), where
        available. You should change your password regularly.
      </TextSmall>
      <TextSmall>
        We will be happy to provide you with more detailed information on
        request. Please contact our data protection officer (see under A.(3)).
      </TextSmall>
    </>
  );
};

export default DataSecurity;
